/**
 * Created by liubo on 16/1/28.
 */
import  keyMirror  from './keyMirror';

//转换成对象
//输入["a", "b"]
//输出{"a":"a", "b":"b"}
const type = ["REQUEST", "SUCCESS", "FAILURE"];

var createObj = (keys) => {
    const obj = {};
    keys.forEach((k, i, arr)=>{
        obj[k] = null;
        type.forEach((t)=>{
            obj[k + "_" + t] = null;
        });
    });
    return obj;
};

//创建常量
export default function KeyMirrorPlus(keys){
    return keyMirror(createObj(keys));
};
